var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9675 10.6837C16.874 8.62203 15.113 6.76484 13.2601 5.43317C12.1651 4.6462 11.013 4.02436 9.91213 3.6505C9.46003 3.49696 9.00494 3.38136 8.55827 3.3164C13.0851 1.6772 18.4412 3.72502 21.336 8.73889L17.9675 10.6837ZM16.6675 11.4342L8.68428 16.0434C7.57906 14.2985 6.89504 12.0609 6.68346 9.9428C6.56088 8.71574 6.60027 7.55946 6.79225 6.59355C6.94753 5.81232 7.19362 5.19925 7.49708 4.76891C8.02151 4.72126 8.67552 4.81467 9.42976 5.07083C10.3623 5.38752 11.3833 5.93155 12.3847 6.65123C14.1133 7.89353 15.709 9.60468 16.6675 11.4342ZM5.19088 10.0919C5.41769 12.3624 6.1456 14.816 7.38425 16.7939L4.01547 18.7389C1.12062 13.7249 2.02534 8.06223 5.70864 4.96153C5.54156 5.38086 5.41412 5.8328 5.32103 6.30113C5.09439 7.4414 5.05685 8.7501 5.19088 10.0919Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7159 15.1721L14.1593 14.3388L17.7293 20.5223L16.2859 21.3556L12.7159 15.1721Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52794 4.50257C6.18905 3.91559 6.05777 3.35694 6.60925 3.03854C7.16072 2.72015 7.57889 3.11317 7.91778 3.70014C7.91778 3.70014 7.55551 3.80822 7.17909 4.02554C6.80268 4.24286 6.52794 4.50257 6.52794 4.50257Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLong);
export default __webpack_public_path__ + "static/media/long.8af6475b9393935e946e4faee52977cd.svg";
export { ForwardRef as ReactComponent };